import { post } from './request';

export const recordFireInsuranceConditionsAcceptance = async (
  fireInsuranceAnalysisId: string,
  sendCertificateByEmail: boolean
): Promise<void> => {
  await post('/fire-insurance-proposals/conditions-acceptance', {
    fireInsuranceAnalysisId,
    conditionsAccepted: true,
    sendCertificateByEmail
  });
};
